export default function handleNav(navAnimationDuration) {

    const root              = document.documentElement;
    const navTrigger        = document.querySelector('#nav-trigger');
    const header            = document.querySelector('#header-container');
    const headerHeight      = header.offsetHeight;
    const headerNav         = document.querySelector('#header-nav');
    const headerMedia       = document.querySelector('.header-nav-media img');
    const headerNavLinks    = document.querySelectorAll('.header-nav-links li');
    const headerNavMeta     = document.querySelectorAll('.header-nav-meta li');
    let navIsOpen           = false;

    const toggleNav = (e) => {
        !navIsOpen ? openNav(e) : closeNav(e);
        navIsOpen = !navIsOpen;
    }

    const openNav = (e) => {
        root.classList.add('nav-is-open');
        navTrigger.setAttribute('aria-expanded', true);
        headerNav.style.zIndex = 100;
        headerNav.setAttribute('aria-hidden', false);
        headerNav.removeAttribute('inert');
        headerMedia.style.clipPath = 'inset(0% 0% 0%)';
        headerMedia.style.opacity = '1';
        headerNavLinks.forEach((li, index) => {
            setTimeout(() => {
                li.style.transform = 'translateY(0)';
                li.style.opacity = '1';
            },
            100 * index);
        });
        setTimeout(() => {
            headerNavMeta.forEach((li, index) => {
                setTimeout(() => {
                    li.style.transform = 'translateY(0)';
                    li.style.opacity = '1';
                },
                100 * index);
            });
        }, navAnimationDuration * 1.5);
    }

    const closeNav = (e) => {
        headerMedia.style.clipPath = 'inset(0% 0% 100%)';
        headerMedia.style.opacity = '0';
        headerNavLinks.forEach((li, index) => {
            setTimeout(() => {
                li.style.transform = 'translateY(-15px)';
                li.style.opacity = '0';
            },
            50 * index);
        });
        headerNavMeta.forEach((li, index) => {
            setTimeout(() => {
                li.style.transform = 'translateY(-10px)';
                li.style.opacity = '0';
            },
            50 * index);
        });
        setTimeout(() => {
            root.classList.remove('nav-is-open');
        }, navAnimationDuration);
        setTimeout(() => {
            navTrigger.setAttribute('aria-expanded', false);
            headerNav.style.zIndex = -1;
            headerNav.setAttribute('aria-hidden', true);
            headerNav.setAttribute('inert', true);
            headerNavLinks.forEach((li) => {
                li.style.transform = 'translateY(30px)';
            });
            headerNavMeta.forEach((li) => {
                li.style.transform = 'translateY(20px)';
            });
            headerMedia.style.clipPath = 'inset(100% 0% 0%)';
        }, navAnimationDuration * 2);
    }

    root.style.setProperty('--header-height', headerHeight + 'px');
    root.style.setProperty('--header-animation-duration', navAnimationDuration + 'ms');

    navTrigger.addEventListener('click', toggleNav, false);
    document.addEventListener('keyup', function(e) {
        if (navIsOpen && (e.key === 'Escape')) {
            toggleNav(e);
        }
    }, false);

}
